import { EnrollmentExperienceResponse } from "@/api/types";

import { request } from "./request";

/**
 * Gets whitelabel data given a client and optionally a language
 */
export async function getWhitelabel(client: string, language?: string): Promise<EnrollmentExperienceResponse> {
  const response = await request<EnrollmentExperienceResponse>({
    url: "/whitelabel/get",
    method: "POST",
    data: {
      client_name: client,
      language_key: language || "en",
    },
  });
  return response as EnrollmentExperienceResponse;
}
